import { createSlice } from '@reduxjs/toolkit';
import { createUserAsync, deleteUserAsync, disableUserAsync, getUsersAsync, updateUserAsync } from './userThunk';
import { APIStatus } from '../../common/enums/api-status';
const initialState = {
    status: APIStatus.IDLE
};
export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getUsersAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getUsersAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.allUsers = action.payload;
        })
            .addCase(getUsersAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(createUserAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createUserAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.user = action.payload;
        })
            .addCase(createUserAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateUserAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateUserAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.user = action.payload;
        })
            .addCase(updateUserAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(disableUserAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(disableUserAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.userDisabled = action.payload;
        })
            .addCase(disableUserAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteUserAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteUserAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.user = action.payload;
        })
            .addCase(deleteUserAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default userSlice.reducer;
